"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildApproveOrderRedirectPageLink = void 0;
const buildApproveOrderRedirectPageLink = (orderBackofficeId, catalogSlug, businessUnit) => `https://${window.location.host}/${catalogSlug}/aprovar-venda/${orderBackofficeId}?bu=${businessUnit}`;
exports.buildApproveOrderRedirectPageLink = buildApproveOrderRedirectPageLink;
